import React from 'react';
import { useNavigate } from 'react-router-dom';

const ExpiroSesion = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    // Redirige a la página principal
    navigate('/');
  };

  return (
    <div className="session-expired-container">
      <div className="session-expired-content">
        <h1>Tu sesión ha expirado</h1>
        <p>Por favor, inicia sesión nuevamente para continuar.</p>
        <button onClick={handleRedirect} className="btn btn-primary">
          Volver a la Página Principal
        </button>
      </div>
    </div>
  );
};

export default ExpiroSesion;